import { Component, Input } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';

import { CreateComponent } from 'src/app/property/create/create.component';
import { PropertyService } from 'src/app/property/property.service';
import { setLoading } from 'src/app/redux/actions/user.actions';
import { AppState } from 'src/app/redux/app.state';
import { ConfirmComponent } from 'src/app/support/confirm/confirm.component';
import { Product, Property } from 'src/typings';
import { ProductService } from '../../product.service';

@Component({
  selector: 'app-properties-manager',
  templateUrl: './properties.component.html',
  styleUrls: ['./properties.component.scss']
})
export class PropertiesComponent {
  columnsToDisplay = ['description', 'value', 'menu'];

  constructor(
    private fb: UntypedFormBuilder,
    private propertyService: PropertyService,
    private dialog: MatDialog,
    private productService: ProductService,
    private store: Store<AppState>
  ) {}

  @Input() set product(prod: Product | undefined) {
    this._product = prod;
    if (prod && prod.properties) {
      this.props = prod.properties;
    }
    if (prod && !prod.properties) {
      this.loadProps(prod);
    }
  }

  async loadProps(product: Product) {
    const prod = await this.productService.getOne(product.id).toPromise();
    this.product = prod;
  }

  get product() {
    return this._product;
  }

  _product: Product | undefined;

  props: { id: number; value: string; property: Property }[] = [];

  set loading(value: boolean) {
    this.store.dispatch(setLoading({ payload: value }));
  }

  addProp() {
    if (!this._product) return;
    const dialogRef = this.dialog.open(CreateComponent);
    dialogRef.componentInstance.product = this._product;
    dialogRef.componentInstance.changeEvent.subscribe((newList) => {
      if (newList) {
        this.updateList(newList);
        dialogRef.close();
      }
    });
  }

  updateList(list: { id: number; value: string; property: Property }[]) {
    this.props = list;
  }

  confirmDialog(prop: { id: number; value: string; property: Property }) {
    if (!this._product) return;
    const dialogRef = this.dialog.open(ConfirmComponent);
    dialogRef.componentInstance.confirmEvent.subscribe((value) => {
      if (value === true) this.removeProp(prop);
      dialogRef.close();
    });
  }

  async removeProp(prop: { id: number; value: string; property: Property }) {
    const confirm = window.confirm('Точно удалить?');
    if (!confirm) return;
    this.loading = true;
    try {
      const res = await firstValueFrom(this.propertyService.deletePropertyFromProduct(prop.id));
      this.updateList(res);
    } catch (err) {
      console.error(err);
    }
    this.loading = false;
  }

  updateProp(prop: { id: number; value: string; property: Property }) {
    if (!this._product) return;
    const dialogRef = this.dialog.open(CreateComponent);
    dialogRef.componentInstance.product = this._product;
    dialogRef.componentInstance.prop_row = prop;
    dialogRef.componentInstance.changeEvent.subscribe((newList) => {
      if (newList) {
        this.updateList(newList);
        return dialogRef.close();
      }
    });
  }
}
